import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api, { formatApiError } from "../lib/api";
import { toast } from "sonner";
import Logo from "../components/Logo";
import { Envelope, ArrowLeft } from "@phosphor-icons/react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", {
        email,
        redirect_url: window.location.origin,
      });
      setSent(true);
      toast.success("Si el email existe, te enviamos un link de recuperación");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-app flex items-center justify-center p-4 noise-bg">
      <div className="w-full max-w-md card-base p-8 sm:p-10" data-testid="forgot-card">
        <div className="flex flex-col items-center text-center gap-3 mb-8">
          <Logo size={96} />
          <div>
            <div className="font-display font-black text-2xl tracking-tighter uppercase leading-tight">Athlon Sports</div>
            <div className="text-xs text-muted uppercase tracking-widest">Recuperar Acceso</div>
          </div>
        </div>

        {!sent ? (
          <>
            <h1 className="font-display uppercase font-black text-3xl tracking-tighter mb-2">¿Olvidaste tu contraseña?</h1>
            <p className="text-muted text-sm mb-8">Ingresá tu email y te enviamos un link para crear una nueva.</p>

            <form onSubmit={handleSubmit} className="space-y-5">
              <div>
                <label className="text-xs uppercase tracking-widest text-muted block mb-2">Email</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="input-base"
                  required
                  data-testid="forgot-email-input"
                />
              </div>
              <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="forgot-submit-btn">
                {loading ? "Enviando..." : "Enviar link de recuperación"}
              </button>
            </form>
          </>
        ) : (
          <div className="text-center">
            <Envelope size={56} weight="duotone" className="text-primary-app mx-auto mb-4" />
            <h1 className="font-display uppercase font-black text-2xl tracking-tighter mb-3">Revisá tu email</h1>
            <p className="text-muted text-sm mb-6">
              Si <span className="text-white font-semibold">{email}</span> está registrado, vas a recibir un link para recuperar tu contraseña en los próximos minutos. Revisá tu carpeta de spam si no aparece.
            </p>
          </div>
        )}

        <button onClick={() => navigate("/login")} className="btn-ghost w-full mt-6 flex items-center justify-center gap-2" data-testid="back-to-login">
          <ArrowLeft size={14} weight="bold" /> Volver al login
        </button>
      </div>
    </div>
  );
}
